import CreateAdminUser from 'CreateAdminUser';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Palette } from 'Palette';
import AdminUserAdmin from '../AdminUserAdmin';
import ContactAdmin from '../ContactAdmin';
import ContentVersionViewer from '../ContentVersionViewer';
import GenerateInvitationEmail from '../GenerateInvitationEmail';
import NewContentManagementEditor from '../NewContentManagementEditor';
import PlaceholderContactAdmin from '../PlaceholderContactAdmin';
import { CheckLoginComponentWithKey } from './CheckLoginComponent';
import LookupArticle, { LookupArticleProps } from './LookupArticle';
import LookupOpportunity, { LookupOpportunityProps } from './LookupOpportunity';

const LoginAndFundOpportunity = (props: { type: LookupOpportunityProps['type'] }) => (
  <CheckLoginComponentWithKey>
    <LookupOpportunity type={props.type} />
  </CheckLoginComponentWithKey>
);

const LoginAndArticle = (props: LookupArticleProps) => (
  <CheckLoginComponentWithKey>
    <LookupArticle type={props.type} />
  </CheckLoginComponentWithKey>
);

export function ContentRouteWrapper() {
  return <NewContentManagementEditor />;
}

export function OpportunityInvestorWrapper() {
  const location = useLocation();
  return <LoginAndFundOpportunity type="FundUpdateWithInvestor" key={location.pathname} />;
}

export function OpportunityFundUpdateWrapper() {
  const location = useLocation();
  return <LoginAndFundOpportunity type="FundUpdate" key={location.pathname} />;
}

export function OpportunityAIWizardWrapper() {
  const location = useLocation();
  return <LoginAndFundOpportunity type="AIWizardPage" key={location.pathname} />;
}

export function OpportunityAdminWrapper() {
  const location = useLocation();
  return <LoginAndFundOpportunity type="FundOpportunityAdmin" key={location.pathname} />;
}

export function ContentVersionViewerWrapper({ tone }: { tone: string }) {
  return (
    <CheckLoginComponentWithKey>
      <ContentVersionViewer tone={tone as keyof typeof Palette} />
    </CheckLoginComponentWithKey>
  );
}

export const CreateAdminUserWrapper = () => {
  const { invitationToken } = useParams<{ invitationToken: string }>();
  return <CreateAdminUser invitationToken={invitationToken!} />;
};

export function ContactAdminWithId() {
  const { id } = useParams<{ id: string }>();
  return <ContactAdmin id={id!} key={id!} tone="tone1" />;
}

export function ContactAdminListRoute() {
  const location = useLocation();
  return <ContactAdmin tone="tone1" key={location.pathname} />;
}

export function GenerateInvitationEmailWrapper() {
  return <GenerateInvitationEmail tone="tone1" />;
}

export function AdminUserAdminWithId() {
  const { id } = useParams<{ id: string }>();
  return <AdminUserAdmin adminUserId={id} key={id} tone="tone1" />;
}

export function AdminUserAdminListRoute() {
  const location = useLocation();
  return <AdminUserAdmin tone="tone1" key={location.pathname} />;
}

export function PlaceholderContactAdminWrapper() {
  const { placeholderId } = useParams<{ placeholderId: string }>();
  return <PlaceholderContactAdmin placeholderId={placeholderId!} tone="tone1" />;
}

export { LoginAndFundOpportunity, LoginAndArticle };
